import React from "react";
import Marquee from "react-fast-marquee";
import { Reveal, Eyebrow } from "./Reveal";
import { COURSE } from "../../data/course";

function Row({ items, direction, stroke }) {
  return (
    <Marquee direction={direction} speed={38} gradient={false} className="py-3">
      {items.map((role, i) => (
        <span key={`${role}-${i}`} className="flex items-center">
          <span
            className={`font-display text-4xl font-semibold tracking-tight md:text-6xl ${
              stroke ? "text-stroke" : "text-[#293891]"
            }`}
          >
            {role}
          </span>
          <span className="mx-8 text-[#e63329] md:mx-12">✦</span>
        </span>
      ))}
    </Marquee>
  );
}

export default function Careers() {
  const half = Math.ceil(COURSE.careers.length / 2);
  const rowA = COURSE.careers.slice(0, half);
  const rowB = COURSE.careers.slice(half);

  return (
    <section id="careers" data-testid="careers-section" className="relative overflow-hidden py-24 md:py-32">
      <div className="mx-auto mb-14 max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <Eyebrow>Career Opportunities</Eyebrow>
        </Reveal>
        <div className="mt-6 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
              15 roles. One skillset. Yours.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-xs text-base leading-relaxed text-[#566076]">
              Structured placement assistance opens doors across the entire analytics landscape.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mask-fade-x space-y-2">
        <Row items={rowA} direction="left" stroke={false} />
        <Row items={rowB} direction="right" stroke={true} />
      </div>
    </section>
  );
}
